import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";


function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>
        <Button  className=" mt-3" variant="primary" href={props.ghLink} target="_blank">
          <BsGithub /> &nbsp;
          {props.isBlog ? "Blog" : "GitHub"}
        </Button>
        {"\n"}
        {"\n"}
        &nbsp; &nbsp;
        {props.LinkedLink && (<Button variant="primary"  className=" mt-3" href={props.LinkedLink} target="_blank">
        <FaLinkedin /> &nbsp;
          {props.isBlog ? "Blog" : "LinkedIn"}
        </Button>
        )
        }
        {"\n"}
        {"\n"}
        &nbsp;&nbsp;
        {!props.isBlog && props.demoLink && (
          <Button className=" mt-3"
            variant="primary"
            href={props.demoLink}
            target="_blank"
            
          >
            <CgWebsite /> &nbsp;
            {"Demo"}
          </Button>
          
        )}
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
